











































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IAuthentication from '@/store/models/IAuthentication';
import IInboundDeliveryNotes from '@/store/models/IInboundDeliveryNotes';
import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import InboundDeliveryNotesApi from '../store/api/InboundDeliveryNotesApi';
import moment from 'moment';
import InbounDeliveryNotesDetailApi from '../store/api/InboundDeliveryNotesDetailApi';
import INotification from '@/store/models/INotification';
import NotificationApi from '@/store/api/NotificationApi';
import ListStatusInboundsDeliveryNotesApi from '@/store/api/ListStatusInboundsDeliveryNotesApi';
import IListStatusInbound from '@/store/models/IListStatusInbound';
import IInboundDetail from '@/store/models/IInboundDetail';
import InboundDetailApi from '../store/api/InboundDetailApi';
import IListStatusInboundDeliveryNotes from '../store/models/IListStatusInboundDeliveryNotes';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import CustomerApi from '@/store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
@Component({
    components: {
        Snackbar
    }
})
export default class InboundsShared extends Vue {
    searchInboundDeliveryNotes: string = "";
    permissions: IRolePermission[] = [];
    inboundDeliveryNotesApi : InboundDeliveryNotesApi;
    inboundDeliveryNotesList : IInboundDeliveryNotes[] = [];
    selectedInboundDeliveryNotes : IInboundDeliveryNotes [] = [];
    companyId : string = "";
    userName: string = "";
    isValid: boolean = true;
    dateIn: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    dialog: boolean = false;
    inboundDeliveryNotesDetailList : IInboundDeliveryNotesDetail[] = [];
    inboundDeliveryNotesDetailApi: InbounDeliveryNotesDetailApi;
    menu2: boolean = false;
    statusInboundsList : IListStatusInboundDeliveryNotes[] = [];
    listStatusInboundsDeliveryNotesApi : ListStatusInboundsDeliveryNotesApi;
    notificationApi : NotificationApi;
    selectedStatusInbound: IListStatusInboundDeliveryNotes = {} as IListStatusInboundDeliveryNotes;
    inboundDetailDeliveryNotesDetailList: IInboundDetail[] = [];
    overlay: boolean = false;
    inboundDetailApi : InboundDetailApi;
    settingsCompanyApi: SettingsCompanyApi;
    showCustomer: boolean = false;
    customerApi : CustomerApi;
    CustomerList : ICustomer[] = [];
    headers: any = [
        { text: 'Company source',
            align: 'start',
            value: 'companySourceName'
        },
        { text: 'Company destination', value: 'companyDestinationName' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Customer', value: 'customerName' },
        { text: 'Code Delivery Note', value: 'code' },
        { text: 'Dossier Number Source', value: 'codeSource' },
        { text: 'Dossier Number Destination', value: 'codeDestination' },
        { text: 'Estimated Time of Arrival', value: 'dateIn' },
        { text: 'Description', value: 'description' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    headersDeliveryNotesDetail: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet type', value: 'palletName' },
        { text: 'Pallet amount', value: 'palletsAmount' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Good per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Cases loss', value: 'casesLoss' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Language', value: 'language' }
    ];
    sortBy: string = 'dateIn';
    sortByDeliveryNoteDetail: string = 'goodName';
    sortDesc: boolean = false;
    editedIndex : number = -1;
    editedItem : IInboundDeliveryNotes = {
        id: "",
        idInbound: "",
        inboundCode: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        idStatus: "",
        statusName: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }
    defaultItem : IInboundDeliveryNotes = {
        id: "",
        idInbound: "",
        inboundCode: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idWarehouse: "",
        warehouseName: "",
        idCustomer: "",
        customerName: "",
        code: "",
        dateIn: new Date(),
        description: "",
        idStatus: "",
        statusName: "",
        codeDestination: "",
        codeSource: "",
        idDock: "",
        dockName: "",
        dockPicked: false
    }

    constructor() {
        super();
        this.inboundDeliveryNotesApi = new InboundDeliveryNotesApi();
        this.inboundDeliveryNotesDetailApi = new InbounDeliveryNotesDetailApi();
        this.listStatusInboundsDeliveryNotesApi = new ListStatusInboundsDeliveryNotesApi();
        this.notificationApi = new NotificationApi();
        this.inboundDetailApi = new InboundDetailApi("Inbounds");
        this.settingsCompanyApi = new SettingsCompanyApi("Inbounds");
        this.customerApi = new CustomerApi();
    }
    
    async created() {
        await this.getPermissions();
        await this.getStatusInbounds();
        await this.getInboundsDeliveryNotes();
        await this.getCustomers();
    }

    async getCustomers() {
        this.CustomerList = await this.customerApi.GetCustomers();
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Delivery Notes' : 'Edit Delivery Notes'; }
    async getStatusInbounds() {
        this.statusInboundsList = await this.listStatusInboundsDeliveryNotesApi.GetListStatusInboundDeliveryNotes();
    }
   
    get DateInFormatted() {
        return this.formatDate(this.dateIn);
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.selectedInboundDeliveryNotes).length !== 0) {
            if (this.permissions[0].isWritable) {
                return true;
            }
        }
        return false;
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : IInboundDeliveryNotes | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedInboundDeliveryNotes = [];
            this.inboundDetailDeliveryNotesDetailList = [];
        } else {
            this.overlay = true;
            this.selectedInboundDeliveryNotes = [newValue];
            this.getInboundDeliveryNotesDetail(this.selectedInboundDeliveryNotes[0].id);
            this.getInboundDetailsDeliveryNotesDetail(this.selectedInboundDeliveryNotes[0].idInbound);
            this.overlay = false;
        }
    }

    @Watch('selectedInboundDeliveryNotes')
    async onChangeSelectedInboundDeliveryNotes() {
        this.inboundDeliveryNotesDetailList = await this.inboundDeliveryNotesDetailApi.GetInboundDeliveryNotesDetailByIdInboundDeliveryNote(this.selectedInboundDeliveryNotes[0].id);
    }

    async close() : Promise<void> {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    async saveInboundDeliveryNotesShared() {
        if (this.selectedInboundDeliveryNotes) {
            this.selectedInboundDeliveryNotes[0].dateIn = new Date(this.dateIn);
            this.selectedInboundDeliveryNotes[0].description = this.editedItem.description;
            this.overlay = true;
            if (this.selectedStatusInbound.name.toLocaleLowerCase() === 'completed') {
                confirm('Are you sure you want to completed this inbound shared delivery note?') && await this.completeDeliveryNote(this.selectedInboundDeliveryNotes[0].id);
            } else {
                this.showMessageInfo(`The inbound shared deliveryNotes ${this.selectedInboundDeliveryNotes[0].code} has been successfully saved`);
            }
            this.overlay = false;
        }
    }

    async completeDeliveryNote(idDeliveryNote : string) {
        this.overlay = true;
        await this.inboundDeliveryNotesApi.SaveInboundDeliveryNotesToCompleted(idDeliveryNote);
        this.selectedInboundDeliveryNotes[0].idStatus = this.selectedStatusInbound.id;
        await this.inboundDeliveryNotesApi.UpdateInboundDeliveryNotes(this.selectedInboundDeliveryNotes[0]);
        await this.sendNotificationToCompanyDestination();
        await this.getInboundsDeliveryNotes();
        this.showMessageInfo(`The inbound shared deliveryNotes ${this.selectedInboundDeliveryNotes[0].code} has been successfully completed`);
        this.dialog = false;
        this.overlay = false;
    }

    async sendNotificationToCompanyDestination() {
        let notification : INotification = {
            subject: "Status delivery note " + this.selectedInboundDeliveryNotes[0].code + " changed to completed",
            body: "The user " + this.userName + " has changed the delivery note " + this.selectedInboundDeliveryNotes[0].code + " to completed",
            type: "INBOUND SHARED DELIVERY NOTE",
            identifier: this.selectedInboundDeliveryNotes[0].id,
            destinationCompany: this.selectedInboundDeliveryNotes[0].idCompanyDestination
        };
        await this.notificationApi.SaveNotification(notification);
        this.showMessageInfo("The notification has been successfully sent to all users of the " + this.selectedInboundDeliveryNotes[0].companyDestinationName + " company.");
    }

    async getInboundDeliveryNotesDetail(idInboundDeliveryNote: string) {
        this.overlay = true;
        this.inboundDeliveryNotesDetailList = await this.inboundDeliveryNotesDetailApi.GetInboundDeliveryNotesDetailByIdInboundDeliveryNote(idInboundDeliveryNote);
        this.overlay = false;
    }

    async getInboundDetailsDeliveryNotesDetail(inboundId: string) {
        this.overlay = true;
        this.inboundDetailDeliveryNotesDetailList = await this.inboundDetailApi.GetInboundsDetailDeliveryNotesDetail(inboundId);
        this.overlay = false;
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.userName = userFromStorage.username;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "InboundsShared"));
        let settingsCompany = SettingsCompany.Settings.ShowCustomer;
        let setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value === "No") {
                this.showCustomer = false;
            } else {
                this.showCustomer = true;
            }
        }
    }

    async getInboundsDeliveryNotes() {
        let statusPending: IListStatusInboundDeliveryNotes = {} as IListStatusInboundDeliveryNotes;
        if (this.statusInboundsList.length > 0) {
            statusPending = this.statusInboundsList.find(s => s.isFinished === false) as IListStatusInboundDeliveryNotes;
            if (statusPending.id !== '' && statusPending.id !== undefined) {
                this.inboundDeliveryNotesList = await this.inboundDeliveryNotesApi.GetInboundDeliveryNotesShared(this.companyId, statusPending.id);
                if (this.showCustomer === false) {
                    this.inboundDeliveryNotesList.forEach((i) => {
                        let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                        if (indexCustomer !== -1) {
                            if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                                i.customerName = "";
                            }
                        } else {
                            i.customerName = "";
                        }
                    });
                }
            }
        }
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    editInboundDeliveryNotes (item: any, dbox = true) {
        if (this.selectedInboundDeliveryNotes.length > 0) {
            this.editedIndex = this.inboundDeliveryNotesList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedStatusInbound = this.statusInboundsList.find(c => c.name.toLocaleLowerCase() === 'pending') as IListStatusInboundDeliveryNotes;
            this.dateIn = moment(new Date(item.dateIn)).format('YYYY-MM-DD');
            this.dialog = true;
        }
    }

    select(item : IInboundDeliveryNotes) : void {
        let index : number = this.selectedInboundDeliveryNotes.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedInboundDeliveryNotes = [item];
        } else {
            let inboundDeliveryNotes = this.selectedInboundDeliveryNotes.find(w => w.id === item.id);
            if (!inboundDeliveryNotes) {
                this.selectedInboundDeliveryNotes = [];
            }
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
